/**
 * @fileoverview gRPC-Web generated client stub for label
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v3.20.3
// source: label/label.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js')

var authz_annotations_pb = require('../authz/annotations_pb.js')
const proto = {};
proto.label = require('./label_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.label.LabelServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.label.LabelServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.label.Labels>}
 */
const methodDescriptor_LabelService_List = new grpc.web.MethodDescriptor(
  '/label.LabelService/List',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.label.Labels,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.label.Labels.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.label.Labels)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.label.Labels>|undefined}
 *     The XHR Node Readable Stream
 */
proto.label.LabelServiceClient.prototype.list =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/label.LabelService/List',
      request,
      metadata || {},
      methodDescriptor_LabelService_List,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.label.Labels>}
 *     Promise that resolves to the response
 */
proto.label.LabelServicePromiseClient.prototype.list =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/label.LabelService/List',
      request,
      metadata || {},
      methodDescriptor_LabelService_List);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.label.LabelRecord,
 *   !proto.label.LabelRecord>}
 */
const methodDescriptor_LabelService_Create = new grpc.web.MethodDescriptor(
  '/label.LabelService/Create',
  grpc.web.MethodType.UNARY,
  proto.label.LabelRecord,
  proto.label.LabelRecord,
  /**
   * @param {!proto.label.LabelRecord} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.label.LabelRecord.deserializeBinary
);


/**
 * @param {!proto.label.LabelRecord} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.label.LabelRecord)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.label.LabelRecord>|undefined}
 *     The XHR Node Readable Stream
 */
proto.label.LabelServiceClient.prototype.create =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/label.LabelService/Create',
      request,
      metadata || {},
      methodDescriptor_LabelService_Create,
      callback);
};


/**
 * @param {!proto.label.LabelRecord} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.label.LabelRecord>}
 *     Promise that resolves to the response
 */
proto.label.LabelServicePromiseClient.prototype.create =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/label.LabelService/Create',
      request,
      metadata || {},
      methodDescriptor_LabelService_Create);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.label.LabelRecord,
 *   !proto.label.LabelRecord>}
 */
const methodDescriptor_LabelService_Update = new grpc.web.MethodDescriptor(
  '/label.LabelService/Update',
  grpc.web.MethodType.UNARY,
  proto.label.LabelRecord,
  proto.label.LabelRecord,
  /**
   * @param {!proto.label.LabelRecord} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.label.LabelRecord.deserializeBinary
);


/**
 * @param {!proto.label.LabelRecord} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.label.LabelRecord)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.label.LabelRecord>|undefined}
 *     The XHR Node Readable Stream
 */
proto.label.LabelServiceClient.prototype.update =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/label.LabelService/Update',
      request,
      metadata || {},
      methodDescriptor_LabelService_Update,
      callback);
};


/**
 * @param {!proto.label.LabelRecord} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.label.LabelRecord>}
 *     Promise that resolves to the response
 */
proto.label.LabelServicePromiseClient.prototype.update =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/label.LabelService/Update',
      request,
      metadata || {},
      methodDescriptor_LabelService_Update);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.label.LabelID,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LabelService_Delete = new grpc.web.MethodDescriptor(
  '/label.LabelService/Delete',
  grpc.web.MethodType.UNARY,
  proto.label.LabelID,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.label.LabelID} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.label.LabelID} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.label.LabelServiceClient.prototype.delete =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/label.LabelService/Delete',
      request,
      metadata || {},
      methodDescriptor_LabelService_Delete,
      callback);
};


/**
 * @param {!proto.label.LabelID} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.label.LabelServicePromiseClient.prototype.delete =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/label.LabelService/Delete',
      request,
      metadata || {},
      methodDescriptor_LabelService_Delete);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.label.AttachControlRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LabelService_AttachControl = new grpc.web.MethodDescriptor(
  '/label.LabelService/AttachControl',
  grpc.web.MethodType.UNARY,
  proto.label.AttachControlRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.label.AttachControlRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.label.AttachControlRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.label.LabelServiceClient.prototype.attachControl =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/label.LabelService/AttachControl',
      request,
      metadata || {},
      methodDescriptor_LabelService_AttachControl,
      callback);
};


/**
 * @param {!proto.label.AttachControlRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.label.LabelServicePromiseClient.prototype.attachControl =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/label.LabelService/AttachControl',
      request,
      metadata || {},
      methodDescriptor_LabelService_AttachControl);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.label.AttachControlRequest,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LabelService_DetachControl = new grpc.web.MethodDescriptor(
  '/label.LabelService/DetachControl',
  grpc.web.MethodType.UNARY,
  proto.label.AttachControlRequest,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.label.AttachControlRequest} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.label.AttachControlRequest} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.label.LabelServiceClient.prototype.detachControl =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/label.LabelService/DetachControl',
      request,
      metadata || {},
      methodDescriptor_LabelService_DetachControl,
      callback);
};


/**
 * @param {!proto.label.AttachControlRequest} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.label.LabelServicePromiseClient.prototype.detachControl =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/label.LabelService/DetachControl',
      request,
      metadata || {},
      methodDescriptor_LabelService_DetachControl);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.google.protobuf.Empty,
 *   !proto.label.LabelCategories>}
 */
const methodDescriptor_LabelService_ListCategories = new grpc.web.MethodDescriptor(
  '/label.LabelService/ListCategories',
  grpc.web.MethodType.UNARY,
  google_protobuf_empty_pb.Empty,
  proto.label.LabelCategories,
  /**
   * @param {!proto.google.protobuf.Empty} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.label.LabelCategories.deserializeBinary
);


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.label.LabelCategories)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.label.LabelCategories>|undefined}
 *     The XHR Node Readable Stream
 */
proto.label.LabelServiceClient.prototype.listCategories =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/label.LabelService/ListCategories',
      request,
      metadata || {},
      methodDescriptor_LabelService_ListCategories,
      callback);
};


/**
 * @param {!proto.google.protobuf.Empty} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.label.LabelCategories>}
 *     Promise that resolves to the response
 */
proto.label.LabelServicePromiseClient.prototype.listCategories =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/label.LabelService/ListCategories',
      request,
      metadata || {},
      methodDescriptor_LabelService_ListCategories);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.label.LabelCategoryRecord,
 *   !proto.label.LabelCategoryRecord>}
 */
const methodDescriptor_LabelService_CreateCategory = new grpc.web.MethodDescriptor(
  '/label.LabelService/CreateCategory',
  grpc.web.MethodType.UNARY,
  proto.label.LabelCategoryRecord,
  proto.label.LabelCategoryRecord,
  /**
   * @param {!proto.label.LabelCategoryRecord} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.label.LabelCategoryRecord.deserializeBinary
);


/**
 * @param {!proto.label.LabelCategoryRecord} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.label.LabelCategoryRecord)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.label.LabelCategoryRecord>|undefined}
 *     The XHR Node Readable Stream
 */
proto.label.LabelServiceClient.prototype.createCategory =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/label.LabelService/CreateCategory',
      request,
      metadata || {},
      methodDescriptor_LabelService_CreateCategory,
      callback);
};


/**
 * @param {!proto.label.LabelCategoryRecord} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.label.LabelCategoryRecord>}
 *     Promise that resolves to the response
 */
proto.label.LabelServicePromiseClient.prototype.createCategory =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/label.LabelService/CreateCategory',
      request,
      metadata || {},
      methodDescriptor_LabelService_CreateCategory);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.label.LabelCategoryRecord,
 *   !proto.label.LabelCategoryRecord>}
 */
const methodDescriptor_LabelService_UpdateCategory = new grpc.web.MethodDescriptor(
  '/label.LabelService/UpdateCategory',
  grpc.web.MethodType.UNARY,
  proto.label.LabelCategoryRecord,
  proto.label.LabelCategoryRecord,
  /**
   * @param {!proto.label.LabelCategoryRecord} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  proto.label.LabelCategoryRecord.deserializeBinary
);


/**
 * @param {!proto.label.LabelCategoryRecord} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.label.LabelCategoryRecord)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.label.LabelCategoryRecord>|undefined}
 *     The XHR Node Readable Stream
 */
proto.label.LabelServiceClient.prototype.updateCategory =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/label.LabelService/UpdateCategory',
      request,
      metadata || {},
      methodDescriptor_LabelService_UpdateCategory,
      callback);
};


/**
 * @param {!proto.label.LabelCategoryRecord} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.label.LabelCategoryRecord>}
 *     Promise that resolves to the response
 */
proto.label.LabelServicePromiseClient.prototype.updateCategory =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/label.LabelService/UpdateCategory',
      request,
      metadata || {},
      methodDescriptor_LabelService_UpdateCategory);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.label.LabelCategoryID,
 *   !proto.google.protobuf.Empty>}
 */
const methodDescriptor_LabelService_DeleteCategory = new grpc.web.MethodDescriptor(
  '/label.LabelService/DeleteCategory',
  grpc.web.MethodType.UNARY,
  proto.label.LabelCategoryID,
  google_protobuf_empty_pb.Empty,
  /**
   * @param {!proto.label.LabelCategoryID} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  google_protobuf_empty_pb.Empty.deserializeBinary
);


/**
 * @param {!proto.label.LabelCategoryID} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.google.protobuf.Empty)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.google.protobuf.Empty>|undefined}
 *     The XHR Node Readable Stream
 */
proto.label.LabelServiceClient.prototype.deleteCategory =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/label.LabelService/DeleteCategory',
      request,
      metadata || {},
      methodDescriptor_LabelService_DeleteCategory,
      callback);
};


/**
 * @param {!proto.label.LabelCategoryID} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.google.protobuf.Empty>}
 *     Promise that resolves to the response
 */
proto.label.LabelServicePromiseClient.prototype.deleteCategory =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/label.LabelService/DeleteCategory',
      request,
      metadata || {},
      methodDescriptor_LabelService_DeleteCategory);
};


module.exports = proto.label;

